import React, { useState } from 'react';
import { Header, Modal, Button, Segment } from 'semantic-ui-react';
import styles from './VehicleKillQuestions.module.scss';

const VehicleKillQuestions = ({ onContinue, onCancel }) => {
	const [showContactAgent, setShowContactAgent] = useState(false);

	return (
		<div>
			<Modal open={showContactAgent} onClose={() => setShowContactAgent(false)} size='tiny'>
				<Modal.Header>Contact Your Agent</Modal.Header>
				<Modal.Content>Please contact your agent for further assistance.</Modal.Content>
				<Modal.Actions>
					<Button id="closeBtn" onClick={() => setShowContactAgent(false)} primary>Close</Button>
				</Modal.Actions>
			</Modal>
			<Segment>
				<Header>Do any of the following apply?</Header>
				<div>
					<ul>
						<li>Is there existing damage on this vehicle?</li>
						<li>Is this vehicle used in racing events or considered to have "hot rod" characteristics?</li>
						<li>Is this vehicle used in transportation services such as Uber or Lyft?</li>
						<li>Is this vehicle titled to someone not listed as a policyholder?</li>
						<li>Has this vehicle been modified / have special equipment or declared as a classic or antique automobile?</li>
						<li>Is this vehicle not normally considered a private passenger type vehicle including, but not limited to limousines or hearses, golf carts and ATV's?</li>
						<li>Is this vehicle used in Business or Farm?</li>
					</ul>
				</div>
			</Segment>
			<div className={styles.buttons}>
				<Button id="yesBtn" primary onClick={() => setShowContactAgent(true)}>
					Yes
				</Button>
				<Button id="noBtn" primary onClick={onContinue}>
					No
				</Button>
				<Button id="cancelBtn" primary onClick={onCancel}>
					Cancel
				</Button>
			</div>
		</div>
	);
};

VehicleKillQuestions.propTypes = {};

export default VehicleKillQuestions;
